import { VehicleType } from "@app/enum/VehicleType.enum";
import { IAccount } from "@app/services/account.service";
import { DeviceHealthRecord } from "./device-health-record";

export class DeviceHealthRecordsByVehicle {
    records: DeviceHealthRecord[];
    
    accountId: number;
    companyName: string;
    
    vehicleId?: number;
    vehicleType?: VehicleType;
    vehicleRegistration?: string;
    vehicleMake?: string;
    vehicleModel?: string;

    constructor(records: DeviceHealthRecord[], account: IAccount) {
        this.records = records;
        this.accountId = account.Id;
        this.companyName = account.CompanyName;

        if (records.length > 0) {
            this.vehicleId = records[0].VehicleId;
            this.vehicleType = records[0].VehicleType;
            this.vehicleRegistration = records[0].VehicleRegistration;
            this.vehicleMake = records[0].VehicleMake;
            this.vehicleModel = records[0].VehicleModel;
        }
    }
}